import classNames from 'classnames'
import React, { forwardRef, useContext } from 'react'
import { FormattedMessage } from 'react-intl'

import Link from 'ui/components/Link'
import { Locale } from 'ui/contexts/InternationalizationContext'
import { PageContext } from 'ui/contexts/PageContext'
import { Anchor } from 'ui/utils'

import styles from './styles.module.css'

interface Props {
  className?: string
  focusable?: boolean
  links: {
    isExternal: boolean
    isStatic: boolean
    onClick?: React.MouseEventHandler<HTMLAnchorElement>
    to: string
    translationId: string
  }[]
}

function getHref(
  isExternal: boolean,
  isStatic: boolean,
  locale: Locale,
  to: string
) {
  if (isExternal) {
    return to
  }

  if (isStatic) {
    return `/${locale}${to}`
  }

  return undefined
}

const PageLinks = forwardRef<HTMLAnchorElement, Props>(
  ({ className, focusable = true, links }, ref) => {
    const { locale, slug } = useContext(PageContext)

    return (
      <>
        {links.map(
          ({ isExternal, isStatic, onClick, to, translationId }, index) => {
            const EffectiveLink = isExternal || isStatic ? Anchor : Link

            return (
              <EffectiveLink
                key={to}
                ref={index === 0 ? ref : undefined}
                aria-labelledby={translationId}
                className={classNames(
                  styles.pageLink,
                  {
                    [styles.currentPage]: slug === to,
                  },
                  className
                )}
                href={getHref(isExternal, isStatic, locale, to)}
                tabIndex={focusable ? undefined : -1}
                to={to}
                onClick={onClick}
              >
                <FormattedMessage id={translationId} />
              </EffectiveLink>
            )
          }
        )}
      </>
    )
  }
)

export default PageLinks
